// React
import React from 'react'
import stringify from 'json-stable-stringify'
import momentjs from 'moment-timezone'
// Google Maps API: https://console.developers.google.com/apis/credentials?project=moonsignapp&organizationId=589994498071
import { geocodeByAddress } from 'react-places-autocomplete'
import googleTz from 'node-google-timezone'
// GraphQL
import { graphql } from 'react-apollo'
// GraphQL Mutations
import { calculateSigns } from '../../graphql/mutations/signs'
// Components
import BirthDate from '../Display/BirthDate'
import BirthPlace from '../Display/BirthPlace'
import BirthTime from '../Display/BirthTime'
import Button from '../Display/Button'
import Loading from '../Display/Loading'
import Modal from '../Display/Modal'


class EntryForm extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			loading: { status: false, text: '' },
			birthDate: { day: 0, month: 0, year: 0 },
			birthPlace: { address: '', lat: 0, lng: 0 },
			birthTime: { hour: 12, minute: 0, pm: true, timezone: 'America/New_York', utcOffset: 0 },
			modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false }
		}
	}

	componentWillMount() {
		const { birthDate, birthPlace, birthTime } = this.props
		if (
			birthDate && Object.keys(birthDate).length > 0
			&& birthPlace && Object.keys(birthPlace).length > 0
			&& birthTime && Object.keys(birthTime).length > 0
		) {
			this.setState({ birthDate, birthPlace, birthTime })
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			stringify(this.props.birthDate) !== stringify(nextProps.birthDate)
			|| stringify(this.props.birthPlace) !== stringify(nextProps.birthPlace)
			|| stringify(this.props.birthTime) !== stringify(nextProps.birthTime)
		) {
			const { birthDate, birthPlace, birthTime } = nextProps
			this.setState({ birthDate, birthPlace, birthTime })
		}
	}


	// MODALS
	closeModal = () => this.setState({ modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false } })


	// VALIDATION
	validation = () => (
		this.state.birthDate.day > 0 && this.state.birthDate.month > 0 && this.state.birthDate.year > 0
		&& this.state.birthPlace.address
	)

	missingTimeAndPlace = () => {
		const { birthDate, birthPlace } = this.state
		return (
			birthDate.day > 0 && birthDate.month > 0 && birthDate.year > 0
			&& birthPlace.address === ''
		)
	}

	// INPUT HANDLERS
	handleSelect = (e) => {
		const value = parseInt(e.newValue, 10)
		switch (e.name) {
		case 'birthDay': this.setState({ birthDate: { ...this.state.birthDate, day: value } }); break
		case 'birthMonth': this.setState({ birthDate: { ...this.state.birthDate, month: value } }); break
		case 'birthYear': this.setState({ birthDate: { ...this.state.birthDate, year: value } }); break
		case 'birthHour': this.setState({ birthTime: { ...this.state.birthTime, hour: value } }); break
		case 'birthMinute': this.setState({ birthTime: { ...this.state.birthTime, minute: value } }); break
		case 'birthAmPm': this.setState({ birthTime: { ...this.state.birthTime, pm: e.newValue === 'true' } }); break
		default: this.setState({ birthDate: { ...this.state.birthDate, day: value } })
		}
	}

	handleLocation = (e) => {
		this.setState({ birthPlace: { address: e.address, lat: 0, lng: 0 } })
	}

	handleButton = () => {
		this.setState({ loading: { status: true, text: 'Finding moon sign...' } })
		let { birthDate, birthPlace, birthTime } = this.state
		// Get lat/lng
		geocodeByAddress(birthPlace.address)
			.then(results => {
				const address = results[0].formatted_address
				// Obtain average latitude and langitude
				if (results.length >= 1 && results[0].geometry.location) {
					const lat = results[0].geometry.location.lat().toFixed(2)
					const lng = results[0].geometry.location.lng().toFixed(2)
					// Set timezone
					let { year, month, day } = birthDate
					month -= 1
					let { hour, minute, pm } = birthTime
					// Adjust for am/pm
					if (hour === 12 && !pm) {
						hour = 0
					}
					else if (hour !== 12 && pm) {
						hour += 12
					}
					const timestamp = Date.UTC(year, month, day, hour, minute)
					// Calculate time zone
					googleTz.key(process.env.REACT_APP_GOOGLE_TZ)
					googleTz.data(lat, lng, timestamp, (err, tz) => {
						if (!['ZERO_RESULTS', 'INVALID_REQUEST', 'REQUEST_DENIED'].includes(tz.raw_response.status)) {
							const timezone = tz.raw_response.timeZoneId
							const utcOffset = (tz.raw_response.status === 'ZERO_RESULTS')
								? 0
								: momentjs.tz.zone(timezone).utcOffset(timestamp)
							birthPlace = { address, lat, lng }
							birthTime = { ...birthTime, timezone, utcOffset }
							// Set local state
							this.setState({ birthPlace, birthTime })
							// Calculate signs
							const birthTimeWithoutPm = { hour, minute, timezone, utcOffset }
							this.props.calculateSigns({ variables: { birthDate, birthTime: birthTimeWithoutPm } })
								.then(({ data }) => {
									const { birthSigns } = data.calculateSigns
									// If database is different, update
									if (
										(stringify(birthDate) !== stringify(this.props.birthDate))
										|| (stringify(birthPlace) !== stringify(this.props.birthPlace))
										|| (stringify(birthTime) !== stringify(this.props.birthTime))
										|| (stringify(birthSigns) !== stringify(this.props.birthSigns))
									) {
										this.props.updateBirthData(birthDate, birthPlace, birthTime, birthSigns)
									}
									else {
										this.props.redux.nav.addPage(birthSigns.moon.name, { name: birthSigns.moon.name, degree: birthSigns.moon.degree, minute: birthSigns.moon.minute, motto: birthSigns.moon.motto })
									}
								})
						}
						else {
							console.error(tz.raw_response.status)
							this.setState({
								loading: { status: false, text: '' },
								modal: {
									status: 'visible',
									title: 'Please select a different address.',
									text: tz.raw_response.status,
									action: { text: 'Continue', func: () => this.closeModal()},
									cancel: { text: '', func: () => null },
									loading: false
								}
							})
						}
					})
				}
				else {
					console.error(results)
					this.setState({
						loading: { status: false, text: '' },
						modal: {
							status: 'visible',
							title: 'Please select a different address.',
							text: results[0].formatted_address,
							action: { text: 'Continue', func: () => this.closeModal()},
							cancel: { text: '', func: () => null },
							loading: false
						}
					})
				}
			})
			.catch((error) => {
				console.error(error)
				this.setState({ loading: { status: false, text: '' } })
			})
	}


	render() {
		const {
			loading,
			birthDate,
			birthPlace,
			birthTime,
			modal
		} = this.state
		const { property } = this.props
		return (
			<div>
				<Loading status={loading.status} text={loading.text} />
				<Modal
					status={modal.status}
					title={modal.title}
					text={modal.text}
					action={{ text: modal.action.text, func: modal.action.func }}
					cancel={{ text: modal.cancel.text, func: modal.cancel.func }}
					loading={modal.loading}
				/>
				<div className='capps-form'>
					<BirthDate
						birthDay={birthDate.day}
						birthMonth={birthDate.month}
						birthYear={birthDate.year}
						property={property}
						onSelectChange={this.handleSelect}
					/>
					<BirthTime
						label='time of birth'
						birthHour={birthTime.hour}
						birthMinute={birthTime.minute}
						property={property}
						pm={birthTime.pm}
						onSelectChange={this.handleSelect}
					/>
					<div className='capps-footer' onTouchTap={() => {
						setTimeout(() => {
							window.localStorage.setItem('MoonSignApp:timeAndPlace', true)
							this.props.redux.nav.addPage('')
						}, 20)
					}}>
						<span className='capps-nolink' style={{ fontWeight: '400', fontSize: '14px' }}>If you don’t know your time of birth, leave as-is</span>
					</div>
					<BirthPlace
						address={birthPlace.address}
						onLocationChange={this.handleLocation}
					/>
					<div className='capps-height-100' />
					<div className='capps-height-100' />
					<Button
						action={this.handleButton}
						disabled={!this.validation()}
						text='Continue'
					/>
					{this.props.contactId &&
						<Button
							action={this.props.handleDelete}
							flat={true}
							text={'Delete ' + this.props.nameFirst}
						/>
					}
				</div>
			</div>
		)
	}
}

export default graphql(calculateSigns, { name: 'calculateSigns' })(EntryForm)



// WEBPACK FOOTER //
// ./src/Components/Home/EntryForm.js